import React from 'react';
import { connect } from 'react-redux';
import { getWatchlistUserSetting } from '../../../main-layout/sidebar/reducer';
import OrganizeColumn from '../common/organize-column';
import Const from './../summary/Const';
import { omit } from 'lodash';
import { changeListHideColumnIndex, REDUCER_NAME } from './../reducer';
import currentState from './../../../helpers/CurrentState';
import ConstCommon from './../../../common/Const';

class OrganizeColumnIndex extends React.PureComponent {
  constructor(props) {
    super(props);
    const { wlSetting, changeListHideColumn } = props;
    if (wlSetting && wlSetting.hideColumns) {
      changeListHideColumn(wlSetting.hideColumns);
    }
  }

  render() {
    const { changeListHideColumn, listHideColumnIndex } = this.props;

    return (
      <OrganizeColumn
        listColumn={Object.keys(
          omit(Const.index, Const.listIgnoreColumnInMangageColumn),
        ).map(item => {
          return {
            key: Const.index[item],
            title: `watchListSummary.listTitleIndexTable.${item}`,
          };
        })}
        listUnCheckedColumn={listHideColumnIndex}
        listUnCheckedColumnDefault={
          Const.listHideColumnIndex ||
          currentState.get(
            ConstCommon.listComponent.Watchlist,
            'listHideColumnIndex',
          )
        }
        changeListHideColumn={changeListHideColumn}
      />
    );
  }
}

const mapStateToProps = state => ({
  listHideColumnIndex: state[REDUCER_NAME].listHideColumnIndex,
  wlSetting: getWatchlistUserSetting(state),
});

const mapDispatchToProps = dispatch => {
  return {
    changeListHideColumn: listHideColumn =>
      dispatch(changeListHideColumnIndex(listHideColumn)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizeColumnIndex);
